import Vue from "vue";

export const attachment_categories = {
  photo_gallery: 1,
  external_budget: 2,
  remote_analysis: 3
};

export async function index(lead_number, params) {
  const response = await Vue.prototype.$http.get(
    `/leads/${lead_number}/attachments`, { params }
  );

  return response.data
}

export async function show(id) {
  const response = await Vue.prototype.$http.get('/attachments/' + id);

  return response.data
}

export async function store(lead_number, payload) {
  const response = await Vue.prototype.$http.post(
    `/leads/${lead_number}/attachments`,
    payload
  );

  return response.data;
}